export default "__VITE_ASSET__8zU97ZZM__"